export default "__VITE_ASSET__a889060c__"